import moment from "moment";
import WebSocket from "./websocket.js";

// 初始化WebSocket
const socket = new WebSocket({
  maxLinks: 2 // 设置websocket最大重连次数
});

// 常量定义
const CLIENT_KEY = "hz.socket";

const onceHandlePools = {}; // 消息回调处理池（执行一次就销毁），格式：{'消息类型': {'消息ID': '处理函数'}}
const keepHandlePools = {}; // 消息处理池，格式：{'消息类型': ['处理函数']}

/*
 * 转换为JSON对象
 */
function toJSON(data) {
  if (data && typeof data !== "object") {
    data = JSON.parse(data);
  }
  return data;
}

/*
 * 消息请求
 * @param reqType 请求报文的消息类型
 * @param reqBody 请求报文的消息体
 * @param callback 响应报函数
 */
function request(reqModule, reqType, reqBody, promiseObj) {
  if (!mySocket.connected) {
    eventCacheFn(request, [reqModule, reqType, reqBody, promiseObj]);
    return;
  }
  try {
    const header = {
      msgId: new Date().getTime().toString(),
      moduleType: reqModule,
      msgType: reqType,
      sendTime: moment().format("YYYY-MM-DD HH:mm:ss")
    };

    const message = JSON.stringify({
      header: JSON.stringify(header),
      body: {
        body: JSON.stringify(reqBody)
      }
    });

    if (reqType && promiseObj) {
      if (onceHandlePools[reqType] === undefined) {
        onceHandlePools[reqType] = {};
      }

      // 通过消息类型和消息ID来存放回调处理函数
      onceHandlePools[reqType][header.msgId] = promiseObj;
    }
    socket.send(message);
  } catch (e) {
    console.error("请求WebSocket异常：", e);
  }
}

/**
 * 消息响应
 */
function response(event) {
  console.log(event, 6666);
  let message = null;
  try {
    // 解析消息
    message = toJSON(event.data);
    message.header = toJSON(message.header);
    message.body = toJSON(message.body);
    if (message.body.alarm_type && message.body.alarm_type !== 4) {
      return;
    }
    // 根据消息类型和消息ID获取处理函数
    const msgType = message.header.msgType;
    const msgId = message.header.msgId;
    let pools = null;
    let handle = null;

    // 执行一次性的消息处理函数
    pools = onceHandlePools[msgType];
    if (pools) {
      handle = pools[msgId];

      if (handle) {
        handle.resolve(message.body);
        delete pools[msgId]; // 调用处理函数后删除该函数（每个请求对应的回调函数只处理一次）
      }
    }

    // 执行消息处理函数
    pools = keepHandlePools[msgType];
    if (pools && pools instanceof Array) {
      pools.forEach(handle => {
        try {
          handle(message);
        } catch (e) {
          console.error("执行消息处理时异常：", e);
        }
      });
    }
  } catch (e) {
    console.error("处理WebSocket响应消息异常：", e);
  }
}

class MySocket {
  constructor() {
    // 连接状态
    this.connected = false;
  }

  /**
   * 连接WebSocket
   * @param address 连接地址（可选，默认连接config配置文件中的地址）
   */
  initSocket(address) {
    // debugger
    // const jwt = localStorage.getItem("jwt");
    const token = localStorage.getItem("token");
    // let token = 'NjQ=|qii/PolK3+WiMbVgmQ28Z1I8wjhxlL7ko4WdWDPvWjX21+BeYsVCFVL+KrAK/cvW'
    if (token) {
      // token = token.replace(/[|]/g, "q_q");
      // token = token.replace(/[/]/g, "p_p"); ws://10.73.95.204:6220
      const wsuri = `ws://${location.host}/wsuri/hz-data-community/ws/app/${token}`;
      // const wsuri = `ws://10.73.95.204:6220/ws/4/${jwt}`;
      socket.init(address || wsuri);
    }
  }

  /**
   * 注册消息监听
   * @param {*} msgType 消息类型
   * @param {*} callback 处理函数
   */
  on(msgType, callback) {
    if (keepHandlePools[msgType] === undefined) {
      keepHandlePools[msgType] = [callback];
    } else {
      keepHandlePools[msgType].push(callback);
    }
  }

  /**
   * 注销消息监听
   * @param {*} msgType 消息类型
   * @param {*} callback 处理函数
   */
  off(msgType, callback) {
    const pools = keepHandlePools[msgType];
    if (pools !== undefined) {
      if (callback) {
        const index = pools.indexOf(callback);
        if (index > -1) {
          pools.splice(index, 1);
        }
      } else {
        pools.splice(0, pools.length - 1);
      }
    }
  }

  /*
   * 消息请求
   * @param reqType 请求报文的消息类型
   * @param reqBody 请求报文的消息体
   * @param callback 响应函数
   */
  request(reqModule, reqType, reqBody) {
    return new Promise((resolve, reject) => {
      request(reqModule, reqType, reqBody, { resolve, reject });
    });
  }

  close() {
    socket.close();
  }

  // websocket事件，提供给外部实现处理
  onOpen() {}
  onClose() {}
  onError() {}
}

const mySocket = new MySocket();

let eventCache = []; // 事件缓存
// 缓存事件方法
const eventCacheFn = (fn, params) => {
  if (!mySocket.connected) {
    eventCache.push({
      fn: fn,
      params: params || null
    });
    return true;
  }
  return false;
};
/**
 * 连接成功事件
 */
function onOpen(event) {
  // mySocket.connected = true
  mySocket.onOpen();
  console.log("websocket连接成功");
  if (!mySocket.connected) {
    mySocket.connected = true;
    // 处理缓存事件
    if (eventCache.length > 0) {
      eventCache.forEach(item => {
        item.fn(...item.params);
      });
      eventCache = [];
    }
  }
}

/**
 * 连接关闭事件
 */
function onClose(event) {
  console.log("websocket连接关闭=====>>>", event);
  mySocket.connected = false;
  mySocket.onClose();
}

/**
 * 连接失败事件
 */
function onError(event) {
  console.log("websocket连接失败=====>>>", event);
  mySocket.connected = false;
  mySocket.onError();
}
// 注册事件
socket.on("onmessage", CLIENT_KEY, response);
socket.on("onopen", CLIENT_KEY, onOpen);
socket.on("onclose", CLIENT_KEY, onClose);
socket.on("onerror", CLIENT_KEY, onError);

mySocket.initSocket();
// 全局化socket连接对象
export default {
  install: (app, options) => {
    app.config.globalProperties.$socket = mySocket;
    app.provide("socket", mySocket);
  }
};